module.exports = __webpack_public_path__ + "static/media/psicon.6aa1eb76.svg";